import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FaTimes } from "react-icons/fa";

const handlePreventClick = (e) => {
    e.stopPropagation();
}

const AlertStudio = ({ userSeq, studio_info, list_live, handleFunc }) => {
    const { t } = useTranslation();

    const [onAirLiveList, setOnAirLiveList] = useState([]);

    useEffect(() => {
        if (list_live !== undefined && list_live !== null) {
            const list_onAirLive = list_live.filter(info => info.liveStatus === "Y");
            if (list_onAirLive !== undefined && list_onAirLive !== null) {
                setOnAirLiveList(list_onAirLive);
            }
        }
    }, []);

    return (
        studio_info !== undefined && studio_info !== null &&
        <div className="hc-unified-alert-card hc-studio-alert-card" onClick={handlePreventClick}>
            <div className="hc-unified-alert-header">
                <span className="hc-unified-alert-kicker">ON AIR</span>
                <button type="button" className="hc-unified-alert-close" onClick={() => handleFunc({ selectedFunc: "CONFIRM_ALERT" })} aria-label="닫기">
                    <FaTimes />
                </button>
            </div>
            {
                studio_info.assignedUserSeq === userSeq ?
                    <div className="hc-unified-alert-title">
                        <span>클래스 방송이 종료됩니다.</span>
                        <span>정말로 종료하시겠습니까?</span>
                    </div> :
                    <div className="hc-unified-alert-title">
                        <span>스튜디오와 연결할 수 없습니다.</span>
                        <span>이미 다른 사용자가 사용 중인 스튜디오입니다.</span>
                    </div>
            }
            <div className="hc-unified-alert-details">
                <div className="hc-unified-alert-detail-row">
                    <span className="hc-unified-alert-label">스튜디오</span>
                    <span className="hc-unified-alert-value" title={studio_info.studioName}>
                        <b>{studio_info.studioName}</b>
                    </span>
                </div>
                {
                    onAirLiveList.length > 0 ?
                        <div className="hc-unified-alert-detail-row">
                            <span className="hc-unified-alert-label">OnAir 클래스</span>
                            <span className="hc-unified-alert-value" title={onAirLiveList[0].liveName + "외 " + (onAirLiveList.length - 1)}>
                                <b>{onAirLiveList[0].liveName + (onAirLiveList.length > 1 ? ' 외 ' + (onAirLiveList.length - 1) : '')}</b>
                            </span>
                        </div> :
                        <></>
                }
            </div>
            {
                studio_info.assignedUserSeq === userSeq ?
                    <div className="hc-unified-alert-actions">
                        <button type="button" className="hc-unified-alert-btn hc-unified-alert-btn-danger" onClick={() => handleFunc({ selectedFunc: "DIS_CON_STUDIO", studio_info })}>예</button>
                        <button type="button" className="hc-unified-alert-btn hc-unified-alert-btn-secondary" onClick={() => handleFunc({ selectedFunc: "CONFIRM_ALERT" })}>아니요</button>
                    </div> :
                    <div className="hc-unified-alert-actions">
                        <button type="button" className="hc-unified-alert-btn hc-unified-alert-btn-primary" onClick={() => handleFunc({ selectedFunc: "CONFIRM_ALERT" })}>{t("확인", { ns: "common" })}</button>
                    </div>
            }
        </div>
    );
}

export default AlertStudio;
